import React from 'react';
import { useNotificationsAlertsDetails } from './hooks/notificationAlersDetails.hook';
import NotificationAlertsDetailsModuleView from './NotificationAlertsDetailsModuleView';

import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { ReactComponent as TuLogo } from 'style/_assets/icons/tu_logo.svg';
import { ReactComponent as EquifaxLogo } from 'style/_assets/icons/equifax-logo.svg';
import { ReactComponent as ExperianLogo } from 'style/_assets/icons/experian-logo.svg';
import { ReactComponent as CSLogo } from 'style/_assets/logos/CS_Logo_Blue.svg';
import { useConfig } from 'hook/config.hook';

const bureauLogo = {
  TRANS_UNION: <TuLogo className="transunionLogo" />,
  TRANS_UNION_ETL: <TuLogo className="transunionLogo" />,
  EXPERIAN: <EquifaxLogo height={10} />,
  EQUIFAX: <ExperianLogo height={16} />,
  CS_ETL: <CSLogo height={24} className="csLogoIcon" />,
};
const NotificationAlertsDetailsModuleController = props => {
  const {
    alertDetailsConfig,
    detailsLinkClick,
    goals,
    selectedAlertDetails,
    selectedAlertDetailsError,
    selectedAlertDetailsLoading,
    showNewTemplate,
  } = useNotificationsAlertsDetails();
  const { config } = useConfig();
  const listLinkCallback = attrs => {
    props.eventHandler(CLICK, {
      'Click Tile': attrs.clickTile,
      Vertical: attrs.Vertical,
    });
  };

  const creditCardsAccount =
    props.creditInfo?.debtAnalysis?.creditCardDebt?.accounts.filter(
      acc => acc.status === 'Open',
    );
  return (
    <NotificationAlertsDetailsModuleView
      alertDetailsConfig={alertDetailsConfig}
      bureauLogo={bureauLogo}
      creditCardsAccount={creditCardsAccount}
      creditInfo={props.creditInfo}
      datatestid={props.datatestid}
      detailsLinkClick={detailsLinkClick}
      isMobileView={props.isMobileView}
      listLinkCallback={listLinkCallback}
      location={props.location}
      goals={goals}
      selectedAlertDetails={selectedAlertDetails}
      selectedAlertDetailsError={selectedAlertDetailsError}
      selectedAlertDetailsLoading={selectedAlertDetailsLoading}
      showNewTemplate={showNewTemplate}
      config={config}
      {...props?.extraAttributes}
    />
  );
};

export default NotificationAlertsDetailsModuleController;
